/**
 * Employee Web — `/me/profile/bank` tab route (Plan 05.2-05).
 *
 * Bank account + Tax/SSC (read-only) + EOS preview carry-forward.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { BankTaxTab } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/profile/bank")({
  staticData: { breadcrumb: { labelKey: "me-profile:tabs.bank_tax" } },
  component: BankTabRoute,
});

function BankTabRoute(): JSX.Element | null {
  return <BankTaxTab />;
}
